<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import EventBus from './event/event-bus'
import nem from '../static/js/nem-sdk/index'

export default {
  name: 'App',
  methods: {
    connect() {
      const that = this
      const nemSocket = nem.com.websockets

      that.$message({
        message: 'Connecting to the blockchain..',
        type: 'info',
        showClose: true
      })
      return that.connector.connect().then(() => {
        // here we are connected to the NIS
        that.$message({
          message: 'Connection established',
          type: 'success',
          showClose: true
        })
        // we subscribe to errors channel first
        nemSocket.subscribe.errors(that.connector, (res) => {
          that.$notify({
            message: JSON.stringify(res),
            type: 'error'
          })
        })
        // Subscribe to account data channel to get the price
        nem.com.websockets.subscribe.account.data(that.connector, (response) => {
          // console.log(response)
          const xemValue = nem.utils.format.nemValue(response.account.balance)
          that.$store.dispatch('setBalance', `${xemValue[0]}.${xemValue[1]}`)
        })
        // Request account data
        nemSocket.requests.account.data(that.connector)
      }, (err) => { // eslint-disable-line  padded-blocks
        // Try to reconnect
        // that.reconnect()
        // }
        that.$notify({
          message: JSON.stringify(err),
          type: 'error',
          duration: 0
        })
      }).catch((err) => {
        // Try to reconnect
        // that.reconnect()
        that.$message({
          message: 'Connection ERROR: ' + err,
          type: 'error',
          showClose: true
        })
      })
    },
    reconnect() {
      const that = this
      const nemSocket = nem.com.websockets

      let endpointIndex = that.endpointIndex + 1
      if (endpointIndex >= that.maxNodes) {
        endpointIndex = 0
      }
      that.$store.dispatch('setEndpointIndex', endpointIndex)
      // Replace connector with a new endpoint
      that.connector = nemSocket.connector.create(
        that.socketEndpoint,
        that.address
      )
      that.$message({
        message: 'Trying to reconnect...',
        type: 'info',
        showClose: true
      })
      // Try to establish a connection
      that.connect()
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.token !== ''
    },
    maxNodes() {
      return this.$store.getters.socketEndpoints(this.$NETWORK_ID)
    },
    endpointIndex() {
      return this.$store.getters.endpointIndex
    },
    socketEndpoint() {
      return this.$store.getters.socketEndpoints(this.$NETWORK_ID)[this.$store.getters.endpointIndex]
    },
    namespaceIndex() {
      return this.$store.getters.namespaceIndex
    },
    balance() {
      return this.$store.getters.balance
    },
    address() {
      return this.$store.getters.address
    },
    publicKey() {
      return this.$store.getters.publicKey
    }
  },
  created() {
    const that = this

    EventBus.$on('startNewNemSocket', () => {
      const nemSocket = nem.com.websockets
      that.connector = nemSocket.connector.create(
        that.socketEndpoint,
        that.address
      )
      // connecting to the NIS starts here
      that.connect()
    })

    EventBus.$on('closeSocket', () => {
      that.connector.close()
    })

    if (this.isLogin) {
      EventBus.$emit('startNewNemSocket')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue